import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'

import CollectionsBootstrap from 'modules/custom_resources/lib/EmployeesCollectionsBootstrap'
import CustomTablesListPage from 'modules/employees/pages/CustomTablesListPage'

const Container = () => {
  const { navigation } = useNavigation()

  const { id } = useStrictParams<'id'>()

  return (
    <CustomTablesListPage
      rootRoute={{
        customTablesIndex: () => navigation.employees.id.customTables.fullPath({ id }),
        customTablesDelete: (schemaId: string, valueId: string) =>
          navigation.employees.id.customTables.schemaIdValuesValueIdDelete.fullPath({
            id,
            schemaId,
            valueId,
          }),
        customTablesEdit: (schemaId: string, valueId: string) =>
          navigation.employees.id.customTables.schemaIdValuesValueIdEdit.fullPath({
            id,
            schemaId,
            valueId,
          }),
        customTablesNew: (schemaId: string) =>
          navigation.employees.id.customTables.schemaIdNew.fullPath({ id, schemaId }),
      }}
    />
  )
}

const RootPage = () => {
  return (
    <CollectionsBootstrap>
      <Container />
    </CollectionsBootstrap>
  )
}

export default RootPage
